import React, {useEffect, useState} from "react";
import CardForm from "../../components/form/CardForm";
import fields from "./config/MachineSelectionFormConfig";
import utils from "../../helpers/utils";
import {Actions} from "../../../client/Actions";
import { useTranslation } from 'react-i18next';

const MachineSelectionSection = ({
                                     setSelectedMachine,
                                     format,
                                     setLoader,
                                     notIn,
                                     access,
                                     onSaved
                                 }) => {

    const { t } = useTranslation();

    const [machines, setMachines] = useState()


    const loadMachines = () => {
        Actions.get("machine", machinesLoaded)
    };

    const machinesLoaded = (data) => {
        if (notIn) {
            //for fonts configuration
            setMachines(data.filter(m => !notIn.includes(m.id)))
        } else {
            //for format creation
            setMachines(data.filter(m => m.formatPartsCount > 0))
        }
    };
    const customSave = (form) => {
        console.log("selected machine: ", form.machine);
        setSelectedMachine(form.machine);
        setLoader(false);
    };


    const [dictionaries, setDictionaries] = useState();

    useEffect(() => {
        if (format && format.machineTypes && machines) {
            const tmp = {};
            tmp["enums/machineType"] = format.machineTypes.filter(type => !format.machines.some(m => m.machineType === type));
            tmp["machine"] = machines;
            setDictionaries(tmp);
        } else if (machines) {
            const tmp = {};
            tmp["enums/machineType"] = utils.unique(machines.map(m => m.machineType));
            tmp["machine"] = machines;
            setDictionaries(tmp);
        }
    }, [format, machines]);

    useEffect(loadMachines, [notIn])

    return (
        <>
            {dictionaries && access &&
                <CardForm
                    title={t("forms.choose_machine")}
                    setLoader={setLoader}
                    fields={fields(t)}
                    width={12}
                    dictionaries={dictionaries}
                    className={"mx-0 px-0"}
                    customSave={customSave}
                    saveButton={t("forms.start_configuration")}
                    reverseButtons={true}
                    postSaved={onSaved}
                />
            }
        </>
    );
};

export default MachineSelectionSection;
